import { render, staticRenderFns } from "./BankAccountClosedAlert.vue?vue&type=template&id=21aa0a8e&scoped=true"
import script from "./BankAccountClosedAlert.vue?vue&type=script&lang=ts"
export * from "./BankAccountClosedAlert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21aa0a8e",
  null
  
)

export default component.exports